import InfoText from '../../../../../elements/InfoText'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import CustomTable from '../../../../../elements/Table/CustomTable'
import React from 'react'
import { Button, Col, Row } from 'antd'

function Existing(props) {
  const { type, setType, members, fetching, fetchURL, next, setMember } = props

  const columns = [
    {
      Header: 'Action',
      accessor: '_id',
      Cell: ({ value }) => (
        <Button
          type="primary"
          icon="plus"
          onClick={() => {
            const member = members.find(i => i._id === value)
            setMember(member)
            setType(member.kind)
            next()
          }}>
          Use This Member
        </Button>
      ),
    },
    {
      Header: 'Full Name',
      accessor: 'fn',
    },
    {
      Header: 'Type',
      accessor: 'kind',
    },
    {
      Header: 'Email',
      accessor: 'email.label',
    },
    {
      Header: 'Phone',
      accessor: 'phone.label',
    },
    {
      Header: 'Mobile',
      accessor: 'mobile.label',
    },
  ]

  return (
    <div style={{ marginTop: 20 }}>
      <Row style={{ textAlign: 'left' }}>
        <Row>
          <InfoText
            text={'Select a current Phonebook Contact or Skip for Creating a new Phone Contact'}
          />
        </Row>
        <br />
        <br />
        <Col span={1}>
          <span>Type: </span>
        </Col>
        <Col span={5}>
          <CustomSelect
            onChange={e => setType(e)}
            value={type}
            data={[
              { key: 'individual', value: 'Individual' },
              { key: 'organisation', value: 'Organisation' },
            ]}
          />
        </Col>
        <br />
        <br />
        <CustomTable
          columns={columns}
          data={members}
          isFilterable={true}
          fetch={fetchURL}
          fetching={fetching}
        />
      </Row>
    </div>
  )
}

export default Existing
